import Vue from 'vue';

import './index.scss';

import lIcon from './index.vue';

Vue.component('l-icon', lIcon);
